import { Link } from 'react-router-dom';
import { films } from '@/mocks/films';

export default function CategoryEntry() {
  const entries = [
    {
      type: 'movie' as const,
      title: '电影',
      desc: '院线新片、类型佳作与影史经典，按题材与地区快速筛选',
      icon: 'ri-film-line',
      count: films.filter((f) => f.type === 'movie').length,
      image:
        'https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20interior%20with%20a%20glowing%20screen%20and%20empty%20red%20velvet%20seats%2C%20deep%20navy%20shadows%20and%20warm%20amber%20light%20spill%2C%20moody%20atmospheric%20composition&width=800&height=520&seq=cat-entry-movie&orientation=landscape',
    },
    {
      type: 'tv' as const,
      title: '电视剧',
      desc: '热播剧集、年代群像与悬疑短剧，一次看完整的剧情脉络',
      icon: 'ri-live-line',
      count: films.filter((f) => f.type === 'tv').length,
      image:
        'https://readdy.ai/api/search-image?query=Cozy%20evening%20living%20room%20with%20a%20large%20television%20casting%20warm%20light%2C%20soft%20sofa%20blanket%20and%20lamp%20glow%2C%20deep%20navy%20and%20amber%20tones%2C%20calm%20cinematic%20interior%20still&width=800&height=520&seq=cat-entry-tv&orientation=landscape',
    },
  ];

  return (
    <section className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4">
      {entries.map((entry) => (
        <Link
          key={entry.type}
          to={`/category/${entry.type}`}
          className="group relative overflow-hidden rounded-lg bg-primary-950 cursor-pointer"
        >
          <div className="relative h-[150px] w-full md:h-[170px]">
            <img
              src={entry.image}
              alt={`${entry.title}分类`}
              title={`${entry.title}分类 - 同学的妈妈影视大全`}
              className="h-full w-full object-cover object-top opacity-80 transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/60 to-transparent" />
          </div>
          <div className="absolute inset-0 flex flex-col justify-center px-5 md:px-6">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
              <i className={`${entry.icon} text-lg w-5 h-5 flex items-center justify-center`} />
            </span>
            <div className="mt-2.5 flex items-baseline gap-2">
              <h2 className="font-heading text-xl font-bold text-background-50">{entry.title}</h2>
              <span className="font-label text-[11px] text-background-200/80">{entry.count} 部在架</span>
            </div>
            <p className="mt-1.5 max-w-[280px] text-xs leading-relaxed text-background-200/85">
              {entry.desc}
            </p>
            <span className="mt-2.5 inline-flex items-center gap-1 text-xs font-medium text-accent-300">
              进入分类
              <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center transition-transform group-hover:translate-x-0.5" />
            </span>
          </div>
        </Link>
      ))}
    </section>
  );
}